export var SIZE_OPTIONS = {
  SMALL: "small",
  NORMAL: "normal"
};
export var TOKENS = {
  height: "height",
  heightLine: "heightLine"
};